import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { Component } from 'react';
import moment from 'moment';
import { Box, Dialog, DialogActions, DialogContent as MuiDialogContent, DialogTitle, FormControl, Grid, IconButton, InputAdornment as MuiInputAdornment, Typography, withStyles } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import { KailonaButton, KailonaDateTimePicker, KailonaTextField } from '@kailona/ui';
import { ProfileManager } from '@kailona/core';
import calculateAge from '../lib/calculateAge';
import calculateBMI from '../lib/calculateBMI';
var GridColumn = withStyles({
  root: {
    '&.left-column': {
      margin: '10px 10px 10px 0',
      width: '180px'
    },
    '&.right-column': {
      margin: '10 0px 10px 10px',
      width: '180px'
    },
    '& > .MuiFormControl-root': {
      width: '100%'
    }
  }
})(Grid);
var DialogContent = withStyles({
  root: {
    height: '100%',
    margin: '0 20px 20px 20px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #EAEAEA',
    borderRadius: '5px',
    paddingBottom: '25px'
  }
})(MuiDialogContent);
var InputAdornment = withStyles({
  root: {
    '& p': {
      fontSize: '10px'
    }
  }
})(MuiInputAdornment);
var styles = {
  uneditable: {
    container: {
      display: 'flex',
      alignItems: 'center'
    },
    value: {
      margin: '0 10px',
      borderBottom: '1px dashed #3F51B5',
      minWidth: '15px'
    },
    unit: {
      fontSize: '10px',
      color: '#999999'
    }
  }
};

var PhysicalDataEditModal = /*#__PURE__*/function (_Component) {
  _inherits(PhysicalDataEditModal, _Component);

  var _super = _createSuper(PhysicalDataEditModal);

  function PhysicalDataEditModal(props) {
    var _this;

    _classCallCheck(this, PhysicalDataEditModal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "toggleModal", function (isOpen) {
      _this.setState({
        isOpen: isOpen
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onInputDataChanged", function () {
      var age = _this.getAge();

      var bmi = _this.getBMI(false);

      _this.setState({
        age: age,
        bmi: bmi
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onConfirm", function () {
      var newPhysicalData = {
        date: moment(_this.dateRef.current.value),
        age: _this.state.age,
        bodyHeight: _this.heightRef.current.value,
        bodyWeight: _this.weightRef.current.value,
        bmi: _this.state.bmi
      };
      var physicalData = _this.props.physicalData;

      _this.props.handleSave(Object.assign({}, physicalData || {}, newPhysicalData));
    });

    _defineProperty(_assertThisInitialized(_this), "getValue", function (text) {
      if (!text || !text.split) {
        return text || '';
      }

      var _text$split = text.split(' '),
          _text$split2 = _slicedToArray(_text$split, 1),
          value = _text$split2[0];

      return value;
    });

    _defineProperty(_assertThisInitialized(_this), "getBMI", function () {
      var useStored = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      var _ref = _this.props.physicalData || {},
          bmi = _ref.bmi;

      if (useStored && bmi) {
        return bmi;
      }

      var age = _this.getAge();

      var weight = _this.getBodyWeight(useStored);

      var height = _this.getBodyHeight(useStored);

      var heightInM = height / 100;
      return calculateBMI(age, weight, heightInM);
    });

    _defineProperty(_assertThisInitialized(_this), "getBodyHeight", function () {
      var useStored = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      var _ref2 = _this.props.physicalData || {},
          bodyHeight = _ref2.bodyHeight;

      if (useStored && bodyHeight) {
        return parseInt(_this.getValue(bodyHeight));
      }

      return _this.heightRef.current && _this.heightRef.current.value;
    });

    _defineProperty(_assertThisInitialized(_this), "getBodyWeight", function () {
      var useStored = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      var _ref3 = _this.props.physicalData || {},
          bodyWeight = _ref3.bodyWeight;

      if (useStored && bodyWeight) {
        return parseInt(_this.getValue(bodyWeight));
      }

      return _this.weightRef.current && _this.weightRef.current.value;
    });

    _defineProperty(_assertThisInitialized(_this), "getAge", function () {
      var _ref4 = _this.props.physicalData || {},
          date = _ref4.date;

      var whenDate = _this.dateRef.current && _this.dateRef.current.value || date || moment();
      return _this.patientDob && calculateAge(_this.patientDob, whenDate);
    });

    _this.state = {
      isOpen: false
    };
    _this.dateRef = /*#__PURE__*/React.createRef();
    _this.heightRef = /*#__PURE__*/React.createRef();
    _this.weightRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(PhysicalDataEditModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var patientDob = ProfileManager.activeProfile.patientDob;
      this.patientDob = patientDob;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _ref5 = this.props.physicalData || {},
          date = _ref5.date,
          bodyHeight = _ref5.bodyHeight,
          bodyWeight = _ref5.bodyWeight;

      var age = this.state.age || this.getAge();
      var bmi = this.state.bmi || this.getBMI();
      return /*#__PURE__*/React.createElement(Dialog, {
        open: this.state.isOpen,
        onClose: function onClose() {
          return _this2.toggleModal(false);
        }
      }, /*#__PURE__*/React.createElement(DialogTitle, null, /*#__PURE__*/React.createElement(Box, {
        display: "flex",
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(Box, {
        flexGrow: 1
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "h3"
      }, t('ehr', this.props.physicalData ? 'Update Physical Data' : 'Add New Physical Data'))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(IconButton, {
        onClick: function onClick() {
          return _this2.toggleModal(false);
        }
      }, /*#__PURE__*/React.createElement(CloseIcon, null))))), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(GridColumn, {
        className: "left-column",
        item: true,
        style: styles.uneditable.container
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body2",
        color: "primary"
      }, t('ehr', 'Age')), /*#__PURE__*/React.createElement(Typography, {
        variant: "body2",
        style: styles.uneditable.value
      }, age)), /*#__PURE__*/React.createElement(GridColumn, {
        className: "right-column",
        item: true,
        style: styles.uneditable.container
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body2",
        color: "primary"
      }, t('ehr', 'Body Mass Index')), /*#__PURE__*/React.createElement(Typography, {
        variant: "body2",
        style: styles.uneditable.value
      }, this.getValue(bmi) || ''), /*#__PURE__*/React.createElement(Typography, {
        style: styles.uneditable.unit
      }, "kg/m2"))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        style: {
          marginTop: '20px'
        }
      }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(KailonaDateTimePicker, {
        inputRef: this.dateRef,
        id: "date",
        ariaLabel: t('ehr', 'Select Date/Time'),
        defaultValue: date ? moment(date) : null,
        onChange: this.onInputDataChanged
      }))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(GridColumn, {
        className: "left-column",
        item: true
      }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(KailonaTextField, {
        inputRef: this.heightRef,
        type: "number",
        id: "height",
        className: "kailona-MuiTextField",
        label: t('ehr', 'Height'),
        defaultValue: this.getValue(bodyHeight),
        InputProps: {
          endAdornment: /*#__PURE__*/React.createElement(InputAdornment, null, "cm")
        },
        onChange: this.onInputDataChanged
      }))), /*#__PURE__*/React.createElement(GridColumn, {
        className: "right-column",
        item: true
      }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(KailonaTextField, {
        inputRef: this.weightRef,
        type: "number",
        id: "weight",
        className: "kailona-MuiTextField",
        label: t('ehr', 'Weight'),
        defaultValue: this.getValue(bodyWeight),
        InputProps: {
          endAdornment: /*#__PURE__*/React.createElement(InputAdornment, null, "kg")
        },
        onChange: this.onInputDataChanged
      })))))), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(KailonaButton, {
        title: t('ehr', 'Cancel'),
        class: "default",
        disabled: this.props.savingPhysicalData,
        onClick: function onClick() {
          return _this2.toggleModal(false);
        }
      }), /*#__PURE__*/React.createElement(KailonaButton, {
        title: t('ehr', 'Confirm'),
        class: "primary",
        disabled: this.props.savingPhysicalData,
        onClick: this.onConfirm,
        loading: this.props.savingPhysicalData
      })));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return PhysicalDataEditModal;
}(Component);

export { PhysicalDataEditModal as default };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(GridColumn, "GridColumn", "/home/runner/html/nextcloud/apps/ehr/js/plugins/physicalData/src/components/PhysicalDataEditModal.js");
  reactHotLoader.register(DialogContent, "DialogContent", "/home/runner/html/nextcloud/apps/ehr/js/plugins/physicalData/src/components/PhysicalDataEditModal.js");
  reactHotLoader.register(InputAdornment, "InputAdornment", "/home/runner/html/nextcloud/apps/ehr/js/plugins/physicalData/src/components/PhysicalDataEditModal.js");
  reactHotLoader.register(styles, "styles", "/home/runner/html/nextcloud/apps/ehr/js/plugins/physicalData/src/components/PhysicalDataEditModal.js");
  reactHotLoader.register(PhysicalDataEditModal, "PhysicalDataEditModal", "/home/runner/html/nextcloud/apps/ehr/js/plugins/physicalData/src/components/PhysicalDataEditModal.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();